import { Button, Result } from 'antd';
import type React from 'react';
import { signOut } from '@/core/providers/AuthFirebaseProvider';
import { AuthLayout } from './AuthLayout';

export const PermissionDeniedView: React.FC = () => {
  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <AuthLayout>
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={[
          <Button key="logout" onClick={handleLogout}>
            Logout
          </Button>,
        ]}
      />
    </AuthLayout>
  );
};
